import React, { useState, useEffect, useRef } from 'react';
import { Table, Input, Space, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export default function LogTable({ data }) {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [globalSearchText, setGlobalSearchText] = useState('');
  const [filteredData, setFilteredData] = useState(data);
  const searchInput = useRef(null);

  const onShowSizeChange = (current, pageSize) => {
    console.log(current, pageSize);
  };

  const columns = [
    {
      title: 'Crop Variety',
      dataIndex: 'crop_variety',
      key: 'crop_variety',
      sorter: (a, b) => a.crop_variety.localeCompare(b.crop_variety),
      render: (value) => <span className={'capitalize'}>{value}</span>,
    },

    {
      title: 'Glasshouse ID',
      dataIndex: 'glasshouse_id',
      key: 'glasshouse_id',
      sorter: (a, b) => a.glasshouse_id.localeCompare(b.glasshouse_id),
    },
    {
      title: 'Bay ID',
      dataIndex: 'bay_id',
      key: 'bay_id',
      sorter: (a, b) => a.bay_id.localeCompare(b.bay_id),
    },
    {
      title: 'Row ID',
      dataIndex: 'row_id',
      key: 'row_id',
      sorter: (a, b) => a.row_id.localeCompare(b.row_id),
    },
    {
      title: 'Drone ID',
      dataIndex: 'drone_id',
      key: 'drone_id',
      sorter: (a, b) => a.drone_id.localeCompare(b.drone_id),
    },
    {
      title: 'Result',
      dataIndex: 'result',
      key: 'result',
      render: (value) => {
        const colorClass =
          value === 'success'
            ? 'successGreen'
            : value === 'canceled'
            ? 'alertYellow'
            : 'dangerRed';

        return (
          <span
            className={`bg-${colorClass}/10 rounded p-2 text-${colorClass}`}
          >
            {value}
          </span>
        );
      },
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Time Elapsed',
      dataIndex: 'time_elapsed',
      key: 'time',
      render: (value) => value.toFixed(2),
      sorter: (a, b) => a.time_elapsed - b.time_elapsed,
    },
    {
      title: 'Timestamp',
      dataIndex: 'timestamp',
      key: 'timestamp',
      render: (value) => {
        let date = new Date(value);
        let dateStr = `${date.getFullYear()}-${
          date.getMonth() + 1 < 10 ? '0' : ''
        }${date.getMonth() + 1}-${
          date.getDate() < 10 ? '0' : ''
        }${date.getDate()}`;
        let timeStr = `${date.getHours()}:${date.getMinutes()}`;
        return (
          <div>
            <div>{dateStr}</div>
            <div className='flex justify-center'>{timeStr}</div>
          </div>
        );
      },
      // sorter: (a, b) => a.time_elapsed - b.time_elapsed,
    },
  ];

  const handleGlobalSearch = (input) => {
    console.log({ input });
    setGlobalSearchText(input);
    const newData = data.filter(
      (row) =>
        row.crop_variety.toLowerCase().includes(input.toLowerCase()) ||
        row.drone_id.toLowerCase().includes(input.toLowerCase()) ||
        row.glasshouse_id.toLowerCase().includes(input.toLowerCase()) ||
        row.bay_id.toLowerCase().includes(input.toLowerCase()) ||
        row.row_id.toLowerCase().includes(input.toLowerCase()) ||
        row.description.toLowerCase().includes(input.toLowerCase()) ||
        row.result.toLowerCase().includes(input.toLowerCase()) ||
        row.time_elapsed
          .toString()
          .toLowerCase()
          .includes(input.toLowerCase()) ||
        row.timestamp.toString().toLowerCase().includes(input.toLowerCase())
    );
    setFilteredData(newData);
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type='primary'
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size='small'
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size='small'
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              confirm({
                closeDropdown: true,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type='link'
            size='small'
            onClick={() => {
              close();
            }}
          >
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#39f' : undefined,
        }}
      />
    ),
    onFilter: (value, record) => {
      console.log(value);
      return record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase());
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const finalColumns = columns.map((vals) => {
    const obj = { ...vals, ...getColumnSearchProps(vals.key) };
    return obj;
  });

  return (
    <div>
      <Input.Search
        placeholder='Global Search'
        className='mb-2 globalSearch'
        value={globalSearchText}
        onChange={(e) => handleGlobalSearch(e.target.value)}
        // onSearch={handleGlobalSearch}
      />
      <Table
        columns={finalColumns}
        pagination={{
          // hideOnSinglePage: true,
          position: ['bottomCenter'],
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
        }}
        dataSource={filteredData.map((row) => ({
          ...row,
          key: `${row.drone_id}${row.glasshouse_id}${row.bay_id}${row.row_id}${row.time_elapsed}`,
        }))}
      />
    </div>
  );
}
